<template><div><h1>VUX V2.1.0 发布日志</h1>
<h2><a href="/zh-CN/components/actionsheet.html">Actionsheet</a></h2>
<ul><li>[feature] 支持数组定义菜单 #950 @wuchuguang</li>
</ul>
<h2><a href="/zh-CN/components/datetime.html">Datetime</a></h2>
<ul><li>[fix] 修复`label`宽度没有受限于`group`设置</li>
</ul>
<h2><a href="/zh-CN/components/icon.html">Icon</a></h2>
<ul><li>[feature] 更新`WeUI`样式到最新版本</li>
<li>[change] `type`参数由下划线变为中划线，组件内部做了兼容保证升级时无影响</li>
</ul>
<h2><a href="/zh-CN/components/marquee.html">Marquee</a></h2>
<ul><li>[feature] 新组件</li>
</ul>
<h2><a href="/zh-CN/components/msg.html">Msg</a></h2>
<ul><li>[feature] 新组件</li>
</ul>
<h2><a href="/zh-CN/components/search.html">Search</a></h2>
<ul><li>[feature] 更新到`WeUI`最新代码</li>
<li>[enhance] 当`value`为空时，不显示清除按钮</li>
</ul>
<h2><a href="/zh-CN/components/view-box.html">ViewBox</a></h2>
<ul><li>[feature] 增加`body-padding-top`及`body-padding-bottom`方便设定上下`padding`值</li>
</ul>
<h2><a href="/zh-CN/components/x-button.html">XButton</a></h2>
<ul><li>[feature] 更新到 `WeUI` 最新版本</li>
<li>[feature] 支持 `prop:isLoading`</li>
</ul>
<h2><a href="/zh-CN/components/x-dialog.html">XDialog</a></h2>
<ul><li>[fix] 修复`transition`绑定</li>
</ul>
<h2><a href="/zh-CN/components/x-number.html">XNumber</a></h2>
<ul><li>[feature] 升级`WeUI`样式</li>
<li>[fix] 修复`label`样式不受控于`group`设置</li>
<li>[feature] 支持`align`属性</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.0 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.0-207.vue?6ff87b9c